import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { pageHeadForProvince, getActiveSiteUrl } from "@/lib/seo-helpers";
import { buildBreadcrumbSchema, buildSpeakableSchema } from "@/lib/schema";
import { RECOMMEND_HUBS } from "@/content/recommend-corpus/hubs";

const TITLE = "แนะนำบริการแปลเอกสาร รับรองเอกสาร และวีซ่า 2026";
const DESC =
  "ศูนย์รวมคำแนะนำการเลือกบริการแปลเอกสาร รับรองเอกสาร และวีซ่า แยกตามกลุ่มคนไทยและชาวต่างชาติ พร้อมขั้นตอนและหน่วยงานที่รับรอง ปรึกษาทีมงานได้";

export const Route = createFileRoute("/recommend/")({
  component: RecommendIndex,
  head: () => {
    const site = getActiveSiteUrl();
    return {
      ...pageHeadForProvince({ title: TITLE, description: DESC, path: "/recommend", type: "website" }),
      scripts: [
        { type: "application/ld+json", children: JSON.stringify(buildSpeakableSchema("/recommend")) },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildBreadcrumbSchema([
              { name: "หน้าแรก", url: site },
              { name: "แนะนำบริการ", url: `${site}/recommend` },
            ]),
          ),
        },
      ],
    };
  },
});

function RecommendIndex() {
  return (
    <>
      <SiteHeader />
      <main className="container mx-auto max-w-4xl px-4 py-10">
        <nav aria-label="breadcrumb" className="mb-4 text-sm text-muted-foreground">
          <a href="/" className="hover:underline">หน้าแรก</a> <span>/</span> <span>แนะนำบริการ</span>
        </nav>
        <h1 className="mb-4 text-3xl font-bold md:text-4xl">แนะนำบริการเอกสารและวีซ่า: เลือกให้ถูกตั้งแต่ครั้งแรก</h1>
        <p className="speakable-summary mb-8 rounded-lg border bg-muted/30 p-5 text-sm leading-relaxed">
          การเลือกบริการเอกสารให้ถูกต้องเริ่มจากปลายทาง ไม่ใช่ราคา เอกสารที่จะใช้ต่างประเทศต้องผ่านนิติกรณ์กรมการกงสุล
          เอกสารต่างประเทศที่จะใช้ในไทยต้องผ่านสายการรับรองจากประเทศต้นทางแล้วแปลเป็นภาษาไทย
          และงานวีซ่าตัดสินกันที่ความสอดคล้องของชุดเอกสาร เลือกหมวดด้านล่างเพื่อดูแนวทางที่ตรงกับกรณีของท่าน
        </p>
        <div className="grid gap-4 sm:grid-cols-2">
          {RECOMMEND_HUBS.map((h) => (
            <a key={h.slug} href={`/recommend/${h.slug}`} className="rounded-lg border bg-card p-5 hover:shadow-sm">
              <h2 className="mb-2 text-lg font-semibold">{h.titleTh}</h2>
              <p className="text-sm text-muted-foreground">{h.metaDesc}</p>
            </a>
          ))}
        </div>
      </main>
      <SiteFooter />
    </>
  );
}
